
import { Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { SimpleDonutGraph } from '@lightwaverf/simple-d3-graph';
import { selectAll } from 'd3';
import { DemoAccountService } from '../../../demo-account.service';
import { time } from '../../../services/global-variables.service';

@Component({
    selector: 'lds-y3-donut-chart',
    templateUrl: './y3-donut-chart.component.html',
    styleUrls: ['./y3-donut-chart.component.css'],
    standalone: false
})
export class Y3DonutChartComponent implements OnInit, OnChanges {
	private graph: SimpleDonutGraph;
	loading = true;
	@Input() data: any;
	@Input() status: string;
	@Input() timespan: string;
	@Input() deviceType: string;
	@ViewChild('graph', { static: false }) graphArea: ElementRef;
	demoValue;

	constructor(private demo: DemoAccountService) { }

	ngOnInit() {
		this.timespan = 'weekly'
	}

	ngOnChanges(changes: SimpleChanges) {
		const duration = this.timespan === 'weekly' ? 7 : 30;
		selectAll('.pie-chart-main > .SD-graph > svg').remove();

		if (!changes.data) return

		changes.data.currentValue.subscribe((res: any[]) => {
			let valveCloseDuration = 0;
			let valveOpenDuration = 0;
			if (this.deviceType === 'TRV') {
				res.forEach(record => {
					if (record.value === 0) {
						valveCloseDuration = valveCloseDuration + record.duration;
					} else {
						valveOpenDuration = valveOpenDuration + record.duration;
					}
				})
				res = [
					{ value: 0, duration: valveCloseDuration, percentage: 0, selected: true },
					{ value: 1, duration: valveOpenDuration, percentage: 0, selected: true }
				];
			}
			if (!res.length && this.status) {
				res = [{
					value: this.status === 'on' ? 1 : 0,
					duration: time.day * duration,
					percentage: '100.0',
					selected: true
				}, {
					value: this.status === 'on' ? 0 : 1,
					duration: 1,
					percentage: '0',
					selected: true
				}];
			}

			this.graph = new SimpleDonutGraph(this.graphArea.nativeElement);
			this.loading = false;
			let options: any = { fieldX: 'values', fieldY: 'duration' };

			let data = res.filter((d) => d.value ? true : false);
			const onData = data[0] || { duration: 0 }

			let hours = Math.floor(onData.duration / time.hour);
			let minutes = Math.floor((onData.duration - hours * time.hour) / 60000);

			let remainder = hours % 24;

			let days = 0;

			if (remainder != hours) {
				days = (hours - remainder) / 24;
				hours = remainder;
			}

			this.graph.draw(res, options, { chartArea: { height: 230, margin: { top: 10, bottom: 10 } } });

			if (days > 0) {
				this.graph.addCenterText(`${days} Days ${hours} Hours ${minutes} Minutes on`);
			} else {
				this.graph.addCenterText(`${hours} Hours ${minutes} Minutes on`);
			}
		}, (err: any) => {
			let res: any = [{
				value: this.status === 'on' ? 1 : 0,
				duration: time.day * duration,
				percentage: '100.0',
				selected: true
			}, {
				value: this.status === 'on' ? 0 : 1,
				duration: 1,
				percentage: '0',
				selected: true
			}];
			this.graph = new SimpleDonutGraph(this.graphArea.nativeElement);
			this.loading = false;
			let options: any = { fieldX: 'values', fieldY: 'duration' };
			let data = res.filter((d: { value: any; }) => d.value ? true : false);
			let hours = Math.floor(data[0].duration / time.hour);
			let minutes = Math.floor((data[0].duration - hours * time.hour) / 60000);
			this.graph.draw(res, options, { chartArea: { height: 230, margin: { top: 10, bottom: 10 } } });

			this.graph.addCenterText(`${hours} Hours ${minutes} Minutes on`);
		});
	}

}
